<template>
    <generic-element-tile-container v-if="mode === 'tiles'"
        :id="widget.id"
        :small="small"
        :colClass="elementClass"
        :cardClass="['widget-card']"
        entityName="widget-card"
    >
        <div class="element-data"
             :data-file-id="widget.id"
             :data-type="widget.is_placeholder ? 'widgetplaceholder' : 'widget'"
             :data-properties="JSON.stringify(widget.properties)"
             :data-settings="JSON.stringify(widget.settings)"
             :data-file-name="widget.file_name"
             :data-thumbnail="widget.thumbnail"
             :data-name="widget.name"
             :data-preview-name="widget.preview_url"
             :data-display-name="widget.name"
        />

        <div class="widget-element-tile">
            <generic-element-tile
                :id="`widget-info-${widget.id}`"
                :img="widget"
                :src="widget.thumbnail || '/img/emptyWidget.png'"
                :isWidget="true"
                :height="'150px'"
                :addMode="widget.is_placeholder"
                :noIcon="widget.is_placeholder"
            />
        </div>

        <v-card-actions :id="'widget-actions-' + widget.last_preview" v-if="actionsAvailable">
            <v-btn small icon aria-label="checkbox" v-if="managePrivilege === '1' && widget.editable" @click="selectWidget()" :color="selected ? 'primary' : ''">
                <v-icon>{{ selected ? 'fa-regular fa-square-check' : 'fa-regular fa-square' }}</v-icon>
            </v-btn>
            <widget-hidden-icon v-if="widget.hidden" />
            <v-spacer/>
            <v-btn small icon aria-label="download" v-if="managePrivilege === '1' && widget.editable" @click="downloadWidget()" :color="selected ? 'primary' : ''">
                <v-icon>fa-regular fa-download</v-icon>
            </v-btn>

            <v-btn small icon aria-label="pencil" v-if="managePrivilege === '1' && widget.editable" @click="editWidget()" :color="selected ? 'primary' : ''">
                <v-icon>fa-regular fa-pencil</v-icon>
            </v-btn>

            <v-btn small icon aria-label="trash" v-if="managePrivilege === '1' && widget.editable" @click="deleteWidget()" :color="selected ? 'primary' : ''">
                <v-icon>fa-regular fa-trash</v-icon>
            </v-btn>
        </v-card-actions>
        <v-tooltip-wrapper
            :activator="actionsAvailable ? '#widget-actions-' + widget.id : '#widget-info-' + widget.id"
            v-if="widget.is_placeholder !== true">
            <div v-html="tooltipHtml"/>
        </v-tooltip-wrapper>
    </generic-element-tile-container>

    <widget-element-row v-else
        :widget="widget"
        :viewPrivilege="viewPrivilege"
        :managePrivilege="managePrivilege"
        :selected="selected"
        @delete="deleteWidget"
        @download="downloadWidget"
        @select="selectWidget"
    />
</template>

<script>
    import toaster from "../../common/toaster";
    import VTooltipWrapper from '../../common/v-tooltip-wrapper.vue'
    import GenericElementTile from "../../content/common/genericElementTile.vue";
    import GenericElementTileContainer from "../../content/common/genericElementTileContainer.vue";
    import IconTooltip from "../../common/icon-tooltip.vue";
    import WidgetHiddenIcon from "./widget-hidden-icon.vue";
    import WidgetElementRow from "./widget-element-row.vue";

    export default {
        components: {
            WidgetElementRow,
            WidgetHiddenIcon,
            IconTooltip,
            GenericElementTileContainer,
            GenericElementTile,
            VTooltipWrapper,
        },
        props: [
            'widget',
            'small',
            'mode',
            'viewPrivilege',
            'managePrivilege',
            'dragDrop',
            'elementClass'
        ],
        data: function () {
            return {
                t_added: Lang.langGet("Added at"),
                t_modified: Lang.langGet("Modified at"),
                t_download: Lang.langGet("Download"),
                t_download_failed: Lang.langGet("Downloading widget failed."),
                activeProject: Laravel.activeProject,
                selected: false,
            }
        },
        computed: {
            actionsAvailable: function () {
                return this.managePrivilege === '1';
            },
            tooltipHtml() {
                let data = this.widget.name + '<br/>';
                data = data + (this.widget.showGlobalName ? 'globally available' + '<br/>' : '') + this.t_added + ': ' + this.widget.created_at + '<br/>' + this.t_modified + ': ' + this.widget.updated_at;
                return data;
            }
        },
        methods: {
            editWidget: function () {
                window.location.href = '/administration/widget/edit/' + this.widget.id;
            },
            deleteWidget: function () {
                EaseEventBus.fire('deleteWidget', this.widget);
            },
            downloadWidget: function () {
                axios.get('/administration/widget/download/' + this.activeProject + '/' + this.widget.id)
                    .then((response) => {
                    const url = '/administration/widget/download/' + this.activeProject + '/' + this.widget.id;
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'download');
                    document.body.appendChild(link);
                    link.click();
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }
                    toaster.error(this.t_download_failed);
                });
            },
            selectWidget: function () {
                this.selected = !this.selected;
                EaseEventBus.fire('selectWidgets', {'name': this.widget.name, 'id': this.widget.id, 'selected': this.selected});
            }
        },
        mounted() {
            EaseEventBus.listen('updateWidgetlist', () => {
                this.selected = false;
            });
        }
    }
</script>

<style>
    .widget-card {
        width: 220px;
    }
</style>
